export default {
  "content": "<rect width=\"48\" height=\"48\" rx=\"24\" fill=\"#4141A2\"/><g clip-path=\"url(#clip0_2157_1632)\"><path d=\"M33.757 23.704l-9.462-9.462a.836.836 0 10-1.182 1.183l.142.142-6.833 12.09-1-1a.837.837 0 00-1.182 1.184l4.14 4.14 1.776 1.777a.836.836 0 101.182-1.183l-.996-.992 1.512-.858.963.964a3.763 3.763 0 005.775-4.772l3.842-2.171.142.14a.836.836 0 101.181-1.182zm-7.096-4.73l-7.844 7.843 5.666-10.023 2.178 2.18zm.908 10.053A2.091 2.091 0 0124 30.506l-.633-.635 3.755-2.121c.288.363.446.813.448 1.277z\" fill=\"#fff\"/></g><defs><clipPath id=\"clip0_2157_1632\"><path fill=\"#fff\" transform=\"translate(14 14)\" d=\"M0 0h20v20H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};